import { UnitEnumResponse } from '.generated/api';

const unitConversions: Record<string, Record<string, number>> = {
  [UnitEnumResponse.METERS]: {
    [UnitEnumResponse.CENTIMETERS]: 100.0,
    [UnitEnumResponse.FEET]: 3.2808,
    [UnitEnumResponse.INCHES]: 39.37,
  },
  [UnitEnumResponse.CENTIMETERS]: { [UnitEnumResponse.METERS]: 1.0 / 100.0 },
  [UnitEnumResponse.FEET]: { [UnitEnumResponse.METERS]: 1.0 / 3.2808 },
  [UnitEnumResponse.INCHES]: { [UnitEnumResponse.METERS]: 1.0 / 39.37 },
  [UnitEnumResponse.SQUARE_METERS]: {
    [UnitEnumResponse.SQUARE_FEET]: 10.764,
  },
  [UnitEnumResponse.CUBIC_METERS]: {
    [UnitEnumResponse.CUBIC_FEET]: 35.3146667,
  },
  [UnitEnumResponse.SQUARE_FEET]: {
    [UnitEnumResponse.SQUARE_METERS]: 1.0 / 10.764,
  },
  [UnitEnumResponse.CUBIC_FEET]: {
    [UnitEnumResponse.CUBIC_METERS]: 1.0 / 35.3146667,
  },
};

const siConversions: Record<UnitEnumResponse, UnitEnumResponse> = {
  [UnitEnumResponse.METERS]: UnitEnumResponse.METERS,
  [UnitEnumResponse.CENTIMETERS]: UnitEnumResponse.METERS,
  [UnitEnumResponse.FEET]: UnitEnumResponse.METERS,
  [UnitEnumResponse.INCHES]: UnitEnumResponse.METERS,
  [UnitEnumResponse.SQUARE_METERS]: UnitEnumResponse.SQUARE_METERS,
  [UnitEnumResponse.SQUARE_FEET]: UnitEnumResponse.SQUARE_METERS,
  [UnitEnumResponse.CUBIC_METERS]: UnitEnumResponse.CUBIC_METERS,
  [UnitEnumResponse.CUBIC_FEET]: UnitEnumResponse.CUBIC_METERS,
  [UnitEnumResponse.PERCENTAGES]: UnitEnumResponse.PERCENTAGES,
  [UnitEnumResponse.PIECES]: UnitEnumResponse.PIECES,
};

export const convert = (
  from: UnitEnumResponse,
  to: UnitEnumResponse,
  value: number,
): number | undefined => {
  if (from === to) {
    return value;
  }
  const factor = unitConversions[from]?.[to];
  return factor ? value * factor : undefined;
};

export const convertToSI = (
  from: UnitEnumResponse,
  value: number,
): number | undefined => {
  return convert(from, siConversions[from], value);
};

export const convertFromSI = (
  to: UnitEnumResponse,
  value: number,
): number | undefined => {
  return convert(siConversions[to], to, value);
};
